<script setup>
/**
 * VoiceCostNotice.vue
 *
 * Avviso contestuale: le chiamate vocali hanno un costo/minuto stimato (Vapi
 * dal listino, GPT-Live dal profilo), OLTRE ai normali costi della
 * piattaforma. Renderizza nulla se il canale voce non è abilitato o se il
 * costo stimato è 0, così appare/scompare da solo col valore admin. Gemello
 * di WhatsappCostNotice.
 */
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useVoicePricing } from '../../composables/useVoicePricing';
import { resolveCostNotice } from '../../utils/voiceCostNotice';

// Senza props: listino Vapi (uso storico, card del connettore voicebot).
// Con perMinuteEur: prezzo esplicito (dialog GPT-Live), nessun fetch.
const props = defineProps({
  perMinuteEur: { type: Number, default: null },
  messageKey: { type: String, default: 'voice.costNotice.perMinute' },
});

const { t } = useI18n();
const { pricing, fetchPricing } = useVoicePricing();

onMounted(() => { if (props.perMinuteEur === null) fetchPricing(); });

const fmt = (eur) =>
  new Intl.NumberFormat('it-IT', {
    style: 'currency', currency: 'EUR',
    minimumFractionDigits: 2, maximumFractionDigits: 4,
  }).format(Number(eur) || 0);

const notice = computed(() => resolveCostNotice({ perMinuteEur: props.perMinuteEur, pricing: pricing.value }));
const visible = computed(() => notice.value.visible);
const message = computed(() => t(props.messageKey, { cost: fmt(notice.value.cost) }));
</script>

<template>
  <div
    v-if="visible"
    class="flex items-start gap-2 rounded-md border border-blue-700/60 bg-blue-900/30 px-3 py-2 text-xs text-blue-200"
    role="note"
  >
    <span class="material-icons text-sm text-blue-300 shrink-0" aria-hidden="true">payments</span>
    <span>{{ message }}</span>
  </div>
</template>
